import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const MobiliansPaymentMob = () => {
  return <CommonProcess />;
};

export default MobiliansPaymentMob;
